/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  getResetPasswordLink(agentId) {
    return axios.get(`${this.url}/${agentId}/reset_password_link`);
  }
}

export default new Agents();
